import { useSelector } from "react-redux";
import JobsList from "go-component/components/Job/JobsList";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationLogsJobsIndexPage = (): JSX.Element => {
	const organization = useSelector(selectOrganization);
	const taxIdNo = organization?.more?.print_company_on_pdf ? organization.more?.company_tax_id_no : undefined;
	const companyName = organization?.more?.print_company_on_pdf ? organization.more?.company_name : undefined;
	const pdfOrientation = organization?.more?.pdf_orientation;
	const pdfFontSize = organization?.more?.default_pdf_font_size?.toString();

	return (
		<JobsList
			organization_name={organization.name || ""}
			taxIdNo={taxIdNo}
			companyName={companyName}
			pdfFontSize={pdfFontSize}
			pdfOrientation={pdfOrientation}
		/>
	);
};
export default OrganizationLogsJobsIndexPage;
